import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CollectMetricContentType = '' as const;
export type CollectMetricRequest = undefined;
export type CollectMetricResponses = LinkCommonErrorResponses & {
    /**
     * @description Metric collected
     */
    '200': {
        'application/json': unknown;
    };
};
export type CollectMetricResponseSuccess = CollectMetricResponses['200']['application/json'];
export type CollectMetricSearchParams = undefined;
export type CollectMetricPathParameters = {
    store_slug: string;
};
export const CollectMetricUrl = '/{store_slug}/collect' as const;
export const CollectMetricMethod = 'POST' as const;
export const getCollectMetricUrl = (params: CollectMetricPathParameters) =>
    CollectMetricUrl.replace(/\{(\w+)\}/g, (_match, param: keyof CollectMetricPathParameters) => String(params[param]));
